module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"meta":{"title":"Frequently asked questions","description":"Frequently asked questions"},"categories":["Savings","Compatibility","Usage"]},"fr":{"meta":{"title":"Foire aux questions","description":"Foire aux questions"},"categories":["Économies","Compatibilité","Utilisation"]}}')
  delete Component.options._Ctor
}
